import UserModel from '../model/user-model';
import {isNull} from 'lodash';

/**
 * Article comment
 * 
 * @author wadahkode <mvp.dedefilaras@gmail.com>
 * @since version 1.1.5
 */
export const User = () => {
    return new UserModel('users');
};

export const getCommentsArticle = (article,key) => {
    return article.getCommentsArticle(key);
};

export const getUserAuthBeforeSendComment = () => {
    let btnComment = document.querySelectorAll('.quick-btn-comment');
    
    btnComment.forEach(item => {
        item.addEventListener('click', () => {
            return getUserInfoIsComment().then(user => {
                if (isNull(user)) {
                    sessionStorage.setItem('user-not-auth', 'Anda harus login sebelum melanjutkan!');
                    location.href = '../login.html';
                    
                    return false;
                }
            });
        });
    });
};

export const getUserInfoIsComment = () => {
    return User().getInfo().then(response => response);
};